<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <span class="modal-card-title is-size-5 has-text-centered">
        {{ General.GIVE_KNOWLEDGE }}
      </span>
      <div class="close-button cursor-pointer" @click.stop="$emit('close')">
        <b-icon icon="close" />
      </div>
    </header>

    <div class="modal-content-container has-text-color-8">
      <div class="text-box">
        <label>
          <span class="has-text-weight-bold has-text-color-7">
            {{ history.user_to_give_knowledge_name }}
            <span class="has-text-weight-semibold has-text-color-8">
              {{
                !history.user_to_give_knowledge_id
                  ? `(${General.EXTERNAL_USER})`
                  : ""
              }}
            </span>
          </span>
        </label>
        <div>
          <label class="has-text-weight-bold has-text-color-7">Email: </label>
          <span> {{ history.user_to_give_knowledge_email }}</span>
        </div>
        <div v-if="history.user_to_give_knowledge_capacity_id">
          <label class="has-text-weight-bold has-text-color-7">Lotação: </label>
          <span>{{ getCapacityInfo }}</span>
        </div>
      </div>
      <b-field>
        <template slot="label">
          <div
            class="has-text-color-7 is-6 has-text-weight-semibold is-flex is-align-items-center"
          >
            {{ General.NOTES }}
            <span class="optional-label ml-5">{{ General.OPTIONAL }}</span>
          </div>
        </template>
        <p class="text-box observation">{{ history.observation }}</p>
      </b-field>
    </div>
    <footer class="modal-card-foot"></footer>
  </div>
</template>

<script>
import { App, General } from "@/utils/constants";
import { mapGetters } from "vuex";

export default {
  name: "ModalViewGiveKnowledge",
  props: {
    history: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      App,
      General
    };
  },
  computed: {
    ...mapGetters(["getCapacityById"]),

    getCapacityInfo() {
      const capacity = this.getCapacityById(
        this.history?.user_to_give_knowledge_capacity_id
      );

      return `${capacity.entity.abbreviation}/${
        capacity.abbreviation.includes("/")
          ? capacity.abbreviation.split("/")[1]
          : capacity.abbreviation
      } - ${capacity.description}`;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.modal-card {
  display: flex;
  justify-content: space-between;
  min-height: 300px;
  max-height: 80vh;
  background-color: $color-1;

  @media only screen and (max-width: $tablet) {
    width: 100%;
  }
}

.modal-content-container {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: space-between;
  overflow: auto;
  padding: 0 20px;

  .text-box {
    width: 100%;
    padding: 5px 10px;
    border: solid $border-color 1px;
    background-color: $color-15;
    border-radius: 5px;
    margin-bottom: 15px;
  }
  .observation {
    padding-bottom: 20px;
  }
}
.optional-label {
  font-weight: 400;
  color: $color-13;
}
</style>
